module.exports = __webpack_public_path__ + "media/images/icon-dots-black-76bb5a15d29a55b97f2a90d5dc981a35.svg";